import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ShoppingCartService from '../../../../../services/Public/shoppingCart.service';
function ShoppingCartButton() {
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [total, setTotal] = useState(0);
    var amount = useSelector(x => x.refreshToken);
    useEffect(() => {
        ShoppingCartService.getShoppingCart().then((response) => {
            setNumberOfItems(response.data.numberOfItems);
            setTotal(response.data.total);
        });
    }, [amount])
    var history = useNavigate();
    function navigateToCart() {
        history("/firm/shoppingcart");
    }
    return (
        <>
            <Button onClick={navigateToCart} className="mt-2">
                <FaIcons.FaShoppingCart />
                <span className="badge bg-light ms-2" style={{ color: "black" }}>{numberOfItems}</span>
                <span className="badge bg-light ms-1" style={{ color: "black" }}><NumericFormat value={total} displayType={'text'} decimalScale={2} fixedDecimalScale={true} prefix={'$'} /></span></Button>

        </>
    )
}

export default ShoppingCartButton;